<template>
    <div>
        <app-header></app-header>
        <div class="bg--img bg--embroidery-two">
            <h1 class="text-center pad-top--xl z-up text-white text-caps">
                Embroidery Service
            </h1>
            <h5 class="text-center text-white pad-top--large pad-bottom--xl text-caps">
                <router-link to="/contact-us" class="text-white">
                    Get in touch now for a free quote
                </router-link>
            </h5>
        </div>
        <div class="grid-x grid-padding-x pad-top--xl pad-bottom--xl bg--lilac" style="margin-top:-10px">
            <div class="cell small-12 medium-8">
                <p class="pad--large feature-text">
                    Embroidery is a method used for decorating garments with stitches using
                    threads. It’s a popular and durable type of branding providing a high
                    quality and long-lasting finish which offers great versatility as virtually
                    all garments can be embroidered. With a vast amount of expertise, the latest
                    machinery and in-house embroidery design facility we are able to achieve
                    outstanding results on the most complex of logos.
                </p>
            </div>
            <div class="cell small-12 medium-4">
                <div class="pad--large">
                    <img src="../../../static/images/customisation/eb-bg.png" alt="" />
                </div>
            </div>
        </div>
        <div class="grid-x grid-padding-x pad-top--xl pad-bottom--xl bg--lilac-dk">
            <div class="cell small-12 medium-4">
                <div class="zoom-image">
                    <img src="../../../static/images/customisation/eb-example.png" alt="" />
                </div>
            </div>
            <div class="cell small-12 medium-4">
                <div class="zoom-image">
                    <img src="../../../static/images/customisation/eb-example-2.png" alt="" />
                </div>
            </div>
            <div class="cell small-12 medium-4">
                <div class="zoom-image">
                    <img src="../../../static/images/customisation/eb-example-3.png" alt="" />
                </div>
            </div>
        </div>
        <div class="grid-x grid-padding-x pad-top--xl pad-bottom--xl bg--swoosh-top-right">
            <div class="cell small-12 medium-8 medium-offset-2 text-center">
                <span class="image-decoraction">
                    <img width="70px" src="../../../static/images/customisation/time-money.png" alt="" />
                </span>
                <span class="image-decoraction">
                    <img width="80px" src="../../../static/images/customisation/stopwatch.png" alt="" />
                </span>
                <span class="image-decoraction">
                    <img width="60px" src="../../../static/images/customisation/knowledge.png" alt="" />
                </span>
                <h2 class="feature-heading pad-top pad-bottom">Quick - Cost effective - Experts</h2>
                <p class="feature-text">
                    Our UK based custom embroidery service offers you the ability to brand any
                    garment whether it’s a t-shirt, polo shirt, hoodie, cap or jacket with your
                    company logo for that custom branded corporate clothing look and feel.<br />
                    Embroidery is a premium branding method used commonly on sports and team wear,
                    school uniform, university crests, workwear and corporate golf clothing. Where
                    personalised clothing is needed embroidery is an everyday solution.<br />Create
                    Customised Clothing now with our personalised online t shirt design tool and
                    with our overnight express shipping service you could receive your order the
                    very next day.
                </p>
            </div>
        </div>
        <div class="grid-x grid-padding-x pad-top--xl bg--dk-blue">
            <div class="cell small-12 medium-4 text-center">
                <img width="230px" src="../../../static/images/customisation/barclays.png" alt="" />
            </div>
            <div class="cell small-12 medium-4 text-center">
                <img width="230px" src="../../../static/images/customisation/google.png" alt="" />
            </div>
            <div class="cell small-12 medium-4 text-center">
                <img width="230px" src="../../../static/images/customisation/microsoft.png" alt="" />
            </div>
        </div>
        <div class="grid-x grid-padding-x pad-bottom--xl pad-top bg--dk-blue">
            <div class="cell small-12 medium-4 text-center">
                <img width="230px" src="../../../static/images/customisation/bbc.png" alt="" />
            </div>
            <div class="cell small-12 medium-4 text-center">
                <img width="230px" src="../../../static/images/customisation/british-gas.png" alt="" />
            </div>
            <div class="cell small-12 medium-4 text-center">
                <img width="230px" src="../../../static/images/customisation/bentley.png" alt="" />
            </div>
        </div>
        <div class="grid-x grid-padding-x pad-top--xl pad-bottom--xl bg--swoosh-top-left">
            <div class="cell small-12 medium-8 medium-offset-2 text-center">
                <p class="feature-text">
                    Ideal for all quantity of orders Most suited to artwork containing spot colours
                    containing no gradients Pantone colour matching available Ideal File Formats
                    are .eps, .pdf, .ai Suitable for virtually all types of clothing
                </p>
                <p class="feature-text">
                    <strong>What's involved:</strong><br />
                    Your artwork will be re-created by our embroidery designer to make it machine
                    readable. The embroidery artwork is uploaded to the machine and the correct
                    shades of thread are then loaded. The correct sized embroidery frame is
                    selected based on the dimension of the design. Garments are then framed in
                    position and an embroidery backing is placed on the underside of where the
                    garment will be embroidered.
                </p>
            </div>
        </div>
        <div class="grid-x grid-padding-x pad-top--xl pad-bottom--xl bg--lilac-dk">
            <div class="cell small-12 medium-8 medium-offset-2">
                <div class="video-container">
                    <iframe src="https://www.youtube.com/embed/1zUVEWjE52E" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
            </div>
        </div>
        <div class="grid-x grid-padding-x pad-top--xl pad-bottom--xl bg--swoosh-top-right">
            <div class="cell small-12 medium-8 medium-offset-2 text-center">
                <p class="feature-text">
                    Once embroidered the garments are unframed, the excess backing is removed
                    leaving a clean finish and the garments are then steamed to remove any frame
                    pressure marks.
                </p>
                <p class="feature-text">
                    Some techniques we offer aside of direct embroidery are:
                </p>
                <p class="feature-text">
                    Padloft – By using foam under the stitching we can give the design a 3d effect.
                    Badges – With our in-house laser cutter we are able to produce our own
                    embroidered badges with different backing options. Applique – Where designs
                    have a large background area, we are able to use material to cover the area
                    keeping the stitches and price low.
                </p>
            </div>
        </div>
        <div class="grid-x grid-padding-x pad-top--xxxl pad-bottom--large bg--lilac relative">
            <span class="top-center-badge">
                <img src="../../../static/images/customisation/top-badge.png" alt="" />
            </span>
            <div class="cell small-12">
                <div class="grid-x grid-padding-x">
                    <div class="cell small-12 medium-8 medium-offset-2">
                        <p class="text-center">
                            <span class="button-text">Contact Us</span>
                        </p>
                    </div>
                </div>
                <form v-on:submit="sendContactForm">
                    <div class="grid-x grid-padding-x pad-top">
                        <div class="cell small-12 medium-3 medium-offset-2">
                            <input required v-model="contact.name" class="featured-input" type="text" placeholder="name">
                        </div>
                        <div class="cell small-12 medium-5">
                            <input required v-model="contact.message" class="featured-input" type="text" placeholder="Selection E.g Screen printing">
                        </div>
                    </div>
                    <div class="grid-x grid-padding-x pad-top--small">
                        <div class="cell small-12 medium-4 medium-offset-2">
                            <input required v-model="contact.email" class="featured-input" type="email" placeholder="Email address">
                        </div>
                        <div class="cell small-12 medium-4">
                            <input required v-model="contact.telephone" class="featured-input" type="text" placeholder="Telephone">
                        </div>
                    </div>
                    <div class="grid-x grid-padding-x pad-top">
                        <div class="cell small-12 medium-8 medium-offset-2">
                            <p class="text-center">
                                <button class="button-text link">Send</button>
                            </p>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="grid-x grid-padding-x pad-top--xxxl pad-bottom--large bg--dk-blue">
            <div class="cell small-12">
                <p class="text-center text-white">
                    <img width="50px" src="../../../static/images/customisation/tel.png" alt="" />
                    &nbsp;0116 467 0260&nbsp;
                    <img width="50px" src="../../../static/images/customisation/mail.png" alt="" />
                    &nbsp;info@customisedclothing.com&nbsp;
                    <img width="50px" src="../../../static/images/customisation/clock.png" alt="" />
                </p>
            </div>
        </div>
        <app-footer></app-footer>
    </div>
</template>

<script>
import Header from '@/components/Header/Header';
import Footer from '@/components/Footer/Footer';
import axios from '../../axios';

export default {
    name: 'Embroidery',
    metaInfo() {
        return {
            title: 'Custom embroidered clothing UK | Custom Embroidered shirts & Hoodies',
            titleTemplate: '%s - Customised Clothing',
            meta: [
                { description: 'Get custom embroidered clothing made just for you or your business. Our premium embroidery service uses high-quality threads. Shop our designs today!' },
            ],
            link: [
                { rel: 'canonical', href: 'https://customisedclothing.com/screenprinting' },
            ],
        };
    },
    data() {
        return {
            contact: {
                name: '',
                email: '',
                message: '',
            },
        };
    },
    methods: {
        sendContactForm(event) {
            event.preventDefault();
            axios.post('/Contacts/addContact.json', this.contact)
                .then(() => {
                    this.$router.push('/contact-thankyou');
                });
        },
    },
    components: {
        appHeader: Header,
        appFooter: Footer,
    },
};
</script>



// WEBPACK FOOTER //
// src/components/StaticPages/Embroidery.vue